import type { SxProps, Theme } from '@mui/material/styles';

export const belowArtworkStyles =
  (backgroundImageUrl?: string): SxProps<Theme> =>
  (theme) => ({
    width: '100vw !important',
    height: '280px',
    [theme.breakpoints.up('sm')]: { height: '320px' },
    [theme.breakpoints.up('md')]: { height: '400px' },
    margin: '0 calc(50% - 50vw) !important',
    position: 'relative',
    overflow: 'hidden',
    ...(backgroundImageUrl
      ? {
          backgroundImage: `url("${backgroundImageUrl}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }
      : {}),
    '& [data-testid="wcag-header-foreground-carousel"]': {
      display: 'block',
      width: '100% !important',
      height: '100% !important'
    },
    '& [data-testid="wcag-header-foreground-image"]': { display: 'block' }
  });

export const belowArtworkInnerStyles: SxProps<Theme> = {
  width: '100%',
  height: '100% !important',
  position: 'relative'
};
